import {Route} from "@angular/router";
import {PublicLayout} from "@layouts/public/public.layout";

export const routes: Route[] = [
  {
    path: '',
    component: PublicLayout,
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('@components/pages/public/home/home.component').then(m => m.HomeComponent),
        title: 'Home'
      },
      {
        path: 'home',
        redirectTo: '',
        pathMatch: 'full'
      },
      {
        path: 'developers',
        loadComponent: () => import('@components/pages/public/developers/developers.component').then(m => m.DevelopersComponent),
        title: 'Developers'
      }
    ]
  }
]
